import { render, staticRenderFns } from "./ImageUploadButton.vue?vue&type=template&id=18011f04&scoped=true&"
import script from "./ImageUploadButton.vue?vue&type=script&lang=js&"
export * from "./ImageUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadButton.vue?vue&type=style&index=0&id=18011f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18011f04",
  null
  
)

export default component.exports